import { createContext, useContext, type ReactNode } from 'react';

import { useAuthStore } from '../../../app/store/useAuthStore';
import { useUserCommentNotifications } from '../hooks/useUserCommentNotifications';

type CommentNotificationsContextValue = ReturnType<typeof useUserCommentNotifications>;

const CommentNotificationsContext = createContext<CommentNotificationsContextValue | null>(null);

type CommentNotificationsProviderProps = {
  children: ReactNode;
};

export const CommentNotificationsProvider = ({ children }: CommentNotificationsProviderProps) => {
  const userId = useAuthStore((state) => state.user?.id);
  const value = useUserCommentNotifications({
    userId,
    enabled: Boolean(userId),
  });

  return (
    <CommentNotificationsContext.Provider value={value}>
      {children}
    </CommentNotificationsContext.Provider>
  );
};

export const useCommentNotifications = (): CommentNotificationsContextValue => {
  const context = useContext(CommentNotificationsContext);

  if (!context) {
    throw new Error('useCommentNotifications must be used within CommentNotificationsProvider');
  }

  return context;
};
